import { render, staticRenderFns } from "./ItemActivity.vue?vue&type=template&id=5ba1b365&scoped=true"
import script from "./ItemActivity.vue?vue&type=script&lang=js"
export * from "./ItemActivity.vue?vue&type=script&lang=js"
import style0 from "./ItemActivity.vue?vue&type=style&index=0&id=5ba1b365&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1b365",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba1b365')) {
      api.createRecord('5ba1b365', component.options)
    } else {
      api.reload('5ba1b365', component.options)
    }
    module.hot.accept("./ItemActivity.vue?vue&type=template&id=5ba1b365&scoped=true", function () {
      api.rerender('5ba1b365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/activityCreation/components/ItemActivity.vue"
export default component.exports